import React, { useEffect, useState } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  Button,
  Typography,
  IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Container from '../Container';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      position: 'absolute',
      left: 0,
      display: 'flex',
      backgroundColor: '#7AB2CE',
      fontSize: '0.9rem !important',
      zIndex: -1,
      '& .main-container': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'auto',
        padding: 10,

        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          textAlign: 'center',
         },
      }
    },
    arrow: {
      margin: '0 2em',
      [theme.breakpoints.down('sm')]: {
       display: 'none',
      },
    },
    contactUs: {
      color: '#000',
      padding: 0,
    },
    closeButton: {
      position: 'absolute',
      right: '5vw',
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        top: '10px',
       },
    },
  })
);

const bannerState = (): [boolean, (v: boolean) => void] => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!sessionStorage || sessionStorage.getItem('meetrix-jitsi-promo') !== 'false') {
      setShow(true);
      sessionStorage?.setItem('meetrix-jitsi-promo', 'true');
    }
  }, []);

  return [
    show,
    (v: boolean) => {
      setShow(v);
      sessionStorage?.setItem('meetrix-jitsi-promo', 'false');
    },
  ];
};

const buttonOnClick = () => {
  sessionStorage?.setItem('meetrix-jitsi-promo', 'false');
};


const JitsiPromo = () => {
  const classes = useStyles();
  const [show, setShow] = bannerState();
  
  if(!show) return null;

  return (
    <div className={classes.root}>
      <Container>
        <div>
          Outsource full-time, high-cost Jitsi infrastructure management and maintenance 
          <span className={classes.arrow}>{'>>>'}</span>
          {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'>>>'}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
        </div>
        <a href="/solutions/outsourced-jitsi-infrastructure-management" onClick={buttonOnClick} className={classes.contactUs}>
          Learn More
        </a>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => setShow(false)}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </Container>
    </div>
  );
};

export default JitsiPromo;
